import { Theme } from '@mui/material';

export const footerStyles = (theme: Theme) => ({
	footer: {
		innerWrapper: {
			width: '100%',
			maxWidth: '1400px',
			padding: { xs: '32px 20px 0px', md: '62px 100px 0px' },
			margin: '0 auto',
			textAlign: 'center',
		},
		heading: {
			fontFamily: 'Integral CF',
			fontSize: '13px',
			fontWeight: 600,
			lineHeight: '16px',
			color: '#FFFFFF',
		},
		logo: {
			width: { xs: '143px', md: '190px' },
			height: { xs: '24px', md: '32px' },
			marginBottom: { xs: '57px', md: '64px' },
		},
		column: {
			display: 'flex',
			flexDirection: 'column',
			gap: '8px',
		},
		columnsWrapper: {
			display: 'flex',
			justifyContent: 'space-between',
			flexWrap: { xs: 'wrap', md: 'nowrap' },
			gap: { xs: '24px', md: '0' },
			paddingBottom: { xs: '32px', md: '62px' },
			borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
		},
		columnTitle: {
			fontFamily: 'Montserrat',
			fontSize: '16px',
			fontWeight: 400,
			lineHeight: '16px',
			color: '#FFFFFF',
			opacity: 0.5,
			paddingBottom: '8px',
			textAlign: 'left',
		},
		columnLink: {
			fontFamily: 'Montserrat',
			fontSize: '15px',
			fontWeight: 400,
			lineHeight: '21px',
			color: '#FFFFFF',
			textWrap: 'nowrap',
			textAlign: 'left',
		},
	},
	actionButton: {
		background: '#ffffff',
		textTransform: 'none',
		color: '#000000',
		borderRadius: '50px',
		border: '1px solid #ffffff',
		fontSize: '14px',
		fontWeight: 700,
		lineHeight: '17px',
		fontFamily: 'Montserrat',
		padding: '17px 24px',
		transition: 'all 0.3s ease-in-out',
		'&:hover': { background: '#000000', color: '#ffffff', transition: 'all 0.3s ease-in-out' },
	},
	copyright: {
		innerWrapper: {
			width: '100%',
			maxWidth: '1400px',
			padding: { xs: '32px 20px', md: '32px 100px' },
			margin: '0 auto',
			textAlign: 'center',
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
		},
	},
});
